// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.triple-number-input-container {
  display: flex;
  flex-direction: row;
  gap: var(--dialog-element-gap);
}

.triple-number-input-part {
  display: flex;
  flex-direction: row;
  gap: var(--input-element-gap);
  align-items: center;
}

.triple-number-input-part span {
  font-size: var(--font-size-l);
}

.triple-number-input-part input {
  max-width: unset;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/triple-number-input/TripleNumberInput.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".triple-number-input-container {\n  display: flex;\n  flex-direction: row;\n  gap: var(--dialog-element-gap);\n}\n\n.triple-number-input-part {\n  display: flex;\n  flex-direction: row;\n  gap: var(--input-element-gap);\n  align-items: center;\n}\n\n.triple-number-input-part span {\n  font-size: var(--font-size-l);\n}\n\n.triple-number-input-part input {\n  max-width: unset;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
